<template>
    <div>
        <template v-if="pageView === true || pageView === null">
            <div v-show="pageView === null">
                <preLoader></preLoader>
            </div>
            <div v-show="pageView === true">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Call Center Admin</h1>
                    <router-link to="/addCallCenterAdmin" class="btn btn-primary float-right active"> Add Call Center Admin</router-link>
                    <div class="searching float-right mr-2">
                        <input id="customSearch" type="text" class="form-control search" name="" />
                    </div>
                </div>
                <table id="callCenterAdminTable" class="table" width="100%">
                    <thead>
                        <tr>
                            <th style="display: none;"></th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                            <th>City</th>
                            <th>Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </template>
        <template v-else-if="pageView === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null
            };
        },
        mounted() {
            this.$Progress.start();
            var that = this;
            var callCenterAdminTable = $('#callCenterAdminTable').DataTable({
                processing: true,
                serverSide: true,
                searching: true,
                sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                ajax: {
                    "url": "api/listCallCenterAdmin",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                    "dataSrc": function ( response ) {
                        that.pageView = response.pageView;
                        if(that.pageView == true){
                            return response.records;
                        }else{
                            callCenterAdminTable.destroy();
                            return false;
                        }
                    },
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'name'},
                    {data: 'email'},
                    {data: 'mobile_no'},
                    {render: function(data,type,full){
                        if(full.city != null){
                            return full.city.name;
                        }
                    }},
                    {data: 'status'},
                    {data: 'id', sorting: false, render: function(data,type,full){
                        var $url = '/editCallCenterAdmin/'+full['id'];
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                    }}
                ],
                "order": [[ 0, "desc" ]],
                "initComplete": () => {
                    this.$Progress.finish();
                }
            });
            $('#customSearch').on( 'keyup', function () {
                callCenterAdminTable.search(this.value).draw();
            });
        },
        created() {
            //
        }
    }
</script>
